import React, { Fragment } from 'react'
import v4 from 'uuid/v4'
import { recommendationsActions } from '../../../../../../redux/recommendations'
import RecommendationAdditionBox from './RecommendationAdditionBox'
import ModalWindow from '@kenetto/uikit-modal'
import RecommendationAdditionForm from './RecommendationAdditionForm'
import { connect } from 'react-redux'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { notify } from 'reapop'
import withPolyglot from '../../../../../common/withPolyglot'

class RecommendationAdditionBoxContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false
    }
  }

  toggleModal () {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen
    })
  }

  handleSubmit (content) {
    const { doseNumber, earliest, latest, recommended } = content
    const {pathologyId, addRecommendation, notify} = this.props
    addRecommendation({
      id: v4(),
      date: moment().format('YYYY-MM-DDThh:mm:ssTZD'),
      vaccineCode: null,
      pathologyId,
      doseNumber: parseInt(doseNumber),
      status: 'DUE',
      dateCriterion: {
        earliest,
        recommended,
        latest
      }
    })
    this.toggleModal()
    notify({
      message: this.props.translate('addedRecommendation', true, 'alerts'),
      status: 'info',
      dismissible: true,
      dismissAfter: 5000,
      position: 'bl',
      closeButton: true,
      allowHTML: true,
      buttons: []
    })
  }

  render () {
    return <Fragment>
      <ModalWindow title={this.props.translate('newShotInsertion')} toggleModal={this.toggleModal.bind(this)} modalIsOpen={this.state.modalIsOpen}>
        <RecommendationAdditionForm handleSubmit={this.handleSubmit.bind(this)} />
      </ModalWindow>
      <RecommendationAdditionBox handleClick={this.toggleModal.bind(this)} />
    </Fragment>
  }
}

function mapStateToProps ({plan, currentSelection}) {
  return {
    pathologyId: currentSelection.pathology
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({...recommendationsActions, notify}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withPolyglot(RecommendationAdditionBoxContainer, 'recommendationAddition'))
